import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useQuery } from '@apollo/client';
import { GET_DASHBOARD_CONFIG } from 'queries/dashboards';

const DashboardView = () => {
  const { key }                       = useParams();
  const dashboardConfig               = useQuery(GET_DASHBOARD_CONFIG, { variables: { key: key } })


  const [scriptReady, setScriptReady] = useState(false);

  useEffect(() => {
    var url = dashboardConfig?.data?.dashboard?.url
    if (url == null || url == undefined) return;
    // must be set before embed.js loads
    window.metabaseConfig = {
      theme: { preset: 'light' },
      isGuest: true,
      instanceUrl: url,
    };

    const existing = document.querySelector(`script[src="${url}/app/embed.js"]`);
    if (existing) {
      setScriptReady(true);
    } else {
      const script = document.createElement('script');
      script.src = `${url}/app/embed.js`;
      script.defer = true;
      script.onload = () => setScriptReady(true);
      document.body.appendChild(script);
    }
  }, [dashboardConfig]);

  return (
    <>
      {scriptReady && dashboardConfig?.data?.dashboard ? (
        dashboardConfig.data.dashboard.token ? (
          dashboardConfig.data.dashboard.kind == "DASHBOARD" ?
          <metabase-dashboard token={dashboardConfig.data.dashboard.token} with-title="true" with-downloads="true" style={{ width: '100%', display: 'block' }}/> : 
          <metabase-question  token={dashboardConfig.data.dashboard.token} with-title="true" with-downloads="true" style={{ width: '100%', display: 'block' }}/>
        ) : (
          <>
            <h3>Dashboard could not be loaded</h3>
            {dashboardConfig.error ? (<p>{dashboardConfig.error.message}</p>) : null}
          </>
        )
      ) : (
        <p>Loading dashboard…</p>
      )}
    </>
  );
};

export default DashboardView;